import Vue from 'vue';
import { getDomainName } from 'ui/domain-name';

class ToolbarItem {
	constructor(options) {
		Object.assign(this, {
			title: '',
			icon: '',
			method: '',
			className: ''
		}, options);
	}
}

function setToolbar(dest, src) {
	dest.length = 0;
	if (src) {
		for (let item of src) {
			dest.push(new ToolbarItem(item));
		}
	}
}

export default class {
	constructor() {
		this.appTitle = getDomainName();
		this.title = null;
		this.toolbar = [];
		this.toolbarMenu = [];
		this.tabs = [];
		this.backUrl = null;
	}

	setTitle(title) {
		this.title = title;
		if (title) {
			document.title = `${title} - ${this.appTitle}`;
		} else if (title === null) {
			// do not change title when undefined
			document.title = this.appTitle;
		}
	}

	watchRouter(router) {
		router.beforeEach((to, from, next) => {
			const route = {};
			for (let matched of to.matched) {
				Object.assign(route, matched.meta);
			}

			this.setTitle(route.title ? Vue.prototype.$formatMessage(route.title) : route.title);
			this.backUrl = typeof route.backUrl === 'function' ? route.backUrl(to) : route.backUrl;
			setToolbar(this.toolbar, route.toolbar);
			setToolbar(this.toolbarMenu, route.toolbarMenu);

			this.tabs.length = 0;
			if (route.tabs) {
				for (let tab of route.tabs) {
					this.tabs.push(Object.assign({}, tab));//
				}
			}

			next();
		});
	}
}


// WEBPACK FOOTER //
// ./src/ui/appstate.js